import { render, staticRenderFns } from "./Departure.vue?vue&type=template&id=59104cbe&scoped=true&"
import script from "./Departure.vue?vue&type=script&lang=js&"
export * from "./Departure.vue?vue&type=script&lang=js&"
import style0 from "./Departure.vue?vue&type=style&index=0&id=59104cbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59104cbe",
  null
  
)

export default component.exports